import React, { useEffect, useState } from 'react';
import MenuDataCommon from './MenuItems/CommonMenuItems/menuItems.json';
import AldiMenuData from './MenuItems/AldiMenuItems/AldiMenuItems.json';
import AdminMenuData from './MenuItems/AdminMenuItems/AdminMenuItems.json';
import Domains from '../../global/constants/domain.ts';
import { useNavigate } from 'react-router-dom';
import { Button, Menu, MenuItem } from '@mui/material';
import { ArrowRight, ArrowDropDown } from '@mui/icons-material';

interface MenuItemType {
  label: string;
  id: string;
  path?: string;
  subMenu?: MenuItemType[];
  roleIds?: number[];
}

function Header_Menu({ userRole }: { userRole: number | null }) {
  const [menuData, setMenuData] = useState<MenuItemType[]>([]);
  const [anchorEls, setAnchorEls] = useState<{ [key: string]: HTMLElement | null }>({});
  const navigate = useNavigate();

  useEffect(() => {
    const domain = window.location.hostname;
    if (domain.includes(Domains.ALDI)) {
      setMenuData(AldiMenuData);
    } else if (domain.includes(Domains.ADMIN)) {
      setMenuData(AdminMenuData);
    } else {
      setMenuData(MenuDataCommon);
    }
  }, []);

  const handleOpen = (event: React.MouseEvent<HTMLElement>, id: string) => {
    event.stopPropagation();
    setAnchorEls((prev) => ({ ...prev, [id]: event.currentTarget }));
  };

  const handleClose = (id: string) => {
    setAnchorEls((prev) => ({ ...prev, [id]: null }));
  };

  const closeAllMenus = () => {
    setAnchorEls({});
  };

  const renderSubMenu = (subItems: MenuItemType[], parentId: string) =>
    subItems.map((subItem) => {
      const hasNested = subItem.subMenu && subItem.subMenu.length > 0;
      const id = `${parentId}-${subItem.id}`;

      return (
        <React.Fragment key={id}>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              if (hasNested) {
                handleOpen(e, id);
              } else {
                closeAllMenus();
                if (subItem.path) navigate(subItem.path);
              }
            }}
          >
            {subItem.label}
            {hasNested && <ArrowRight fontSize="small" style={{ marginLeft: 'auto' }} />}
          </MenuItem>

          {hasNested && (
            <Menu
              anchorEl={anchorEls[id]}
              open={Boolean(anchorEls[id])}
              onClose={() => handleClose(id)}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {renderSubMenu(subItem.subMenu!, id)}
            </Menu>
          )}
        </React.Fragment>
      );
    });

  const renderMenu = (item: MenuItemType) => {
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;
    const id = item.id;

    return (
      <div key={id} className='extra'>
        <Button
          id={`button-${id}`}
          aria-controls={hasSubMenu ? `menu-${id}` : undefined}
          aria-haspopup="true"
          className="text-light"
          onClick={(e) =>
            hasSubMenu
              ? handleOpen(e, id)
              : item.path
              ? navigate(item.path)
              : null
          }
          variant="text"
          sx={{ mx: 1, textTransform: 'none', fontWeight: 600 }}
        >
          {item.label}
          {hasSubMenu && <ArrowDropDown />}
        </Button>

        {hasSubMenu && (
          <Menu
            id={`menu-${id}`}
            anchorEl={anchorEls[id]}
            open={Boolean(anchorEls[id])}
            onClose={() => handleClose(id)}
          >
            {renderSubMenu(item.subMenu!, id)}
          </Menu>
        )}
      </div>
    );
  };

  return (
    <div className="d-flex align-items-center">
      {menuData
        .filter((item) => !item.roleIds || item.roleIds.includes(userRole!))
        .map((item) => renderMenu(item))}
    </div>
  );
}

export default Header_Menu;
